import React from 'react';
import { Link } from 'react-router';
import { Logged, LoggedUserName } from '../login/Login';
import {Col} from 'react-bootstrap';
import { browserHistory } from 'react-router'
import { UserLogout } from '../login/Login';

import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
 en:{
   uzivatel:"Signed in as"
 },
 cs: {
   uzivatel:"Přihlášený uživatel"
 }
});


export default class HeaderUserName extends React.Component {

  Logout = () => {
    UserLogout();
    //console.log(this.props);
    this.props.setUser(0,'');
    browserHistory.push('/')
  }

  render() {
    if (Logged()) {
      return (
        <div className="navbar-text navbar-right" style={{float: 'right'}}>
            <span className="d-none d-sm-inline">{strings.uzivatel}</span> <a href="#user-detail" className="navbar-link">{LoggedUserName()}</a>
            <a href="#" className="ml-1" onClick={this.Logout}>
              <i className="fa fa-sign-out navbar-icon" aria-hidden="true"></i>
            </a>
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// src/components/pages/HeaderUserName.js